<template>
  <li>
    <div class="episodes-view__episode">
      <div class="episodes-view__author-wrapper">
        <div class="episodes-view__author" :style="{ backgroundImage: `url('${getAuthorPicture(episode)}')` }"></div>
        <div class="episodes-view__main-info">
          <h1 @click="setCurrentVideo(episode.videoUrl)">{{ episode.title }}</h1>
          <ul class="video-description__tabs tabs">
              <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'desc' }" @click.prevent="selectedTab='desc'">Description</a></li>
              <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'bio' }" @click.prevent="selectedTab='bio'">Bio</a></li>
          </ul>
        </div>
      </div>
      <div class="episodes-view__description">
        <p class="video-description__text" v-if="selectedTab == 'desc'">
          {{ episode.description }}
        </p>
        <p class="video-description__text" v-else>
          {{ episode.bio }}
        </p>
      </div>
    </div>
  </li>
</template>

<style lang="scss">
.episodes-view {
  &__list {
    list-style: none;
    padding: 0 35px 64px 35px;

    li {
      display: block;
      padding: 32px 0;
      position: relative;
    }
  }

  &__author {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    &-wrapper {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      gap: 18px;
      margin-bottom: 11px;
    }
  }

  &__main-info {
    flex: 1;
    h1 {
      font-size: 1em;
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 9px;
    }
  }

  &__description {
    p {
      font-size: 0.75em;
      font-weight: 300;
      line-height: 18px;
    }
  }
}

.tabs {
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  padding: 0;
  margin: 0;
}

  li.tabs__item {
    margin: 0;
    padding: 0;
  }

  .tabs__link {
    font-size: 0.75em;
    font-weight: 700;
    margin-right: 20px;
    display: block;
    line-height: 1em;
    text-transform: uppercase;
    color: #FFF;

    &:hover,
    &:visited,
    &:focus,
    &:active {
      text-decoration: none;
    }

    &:hover,
    &:focus,
    &.active {
      color: #FC8B00;
    }
  }
</style>

<script>
export default {
  name: 'episode',
  props: [
    'episode', 'index'
  ],
  data () {
    return {
      selectedTab: 'desc'
    }
  },
  computed: {
    hasVideos () {
      return this.$store.getters.hasVideos
    }
  },
  methods: {
    setCurrentVideo (index) {
      this.$store.commit('setCurrentVideo', index)
      this.$router.replace('/')
    },
    getAuthorPicture (episode) {
      if (this.hasVideos && episode.authors.length > 0) {
        return episode.authors[0].picture.url
      } else {
        return ''
      }
    }
  }
}
</script>
